"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERRORS = exports.COMMANDS = void 0;
exports.COMMANDS = {
    GET_ADDRESS: "GET_ADDRESS",
    GET_INFO: "GET_INFO",
    SEND_ASSET: "SEND_ASSET",
    GET_PERMISSION: "GET_PERMISSION",
};
exports.ERRORS = {
    REQUEST_TIMEOUT: "Request timed out",
    SEND_INTERNAL: "Error sending message to extension",
};
//# sourceMappingURL=constants.js.map